import React from "react";

import { Routes, Route } from "react-router-dom";
import { PageWrapper } from "./layout";
import * as Pages from "./pages";

function App() {
	return (
		<Routes>
			<Route path="/" element={<PageWrapper />}>
			<Route path="/" element={<Pages.HomePage />} />
				<Route path="/scores" element={<Pages.LeaderBoard />} />
				<Route path="/lobby" element={<Pages.LobbyPage />} />
				<Route path="/room/:id" element={<Pages.RoomPage />} />
				<Route
					path="/profile"
					element={
						<Pages.ProtectedRoute>
							<Pages.ProfilePage />
						</Pages.ProtectedRoute>
					}
				/>
				<Route path="/register" element={<Pages.RegisterPage />} />
				<Route path="/logout" element={<Pages.LogoutPage />} />
				<Route path="*" element={<Pages.NotFoundPage />} />
			</Route>
		</Routes>
	);
}

export default App;
